<template>
  <!-- <div class="comp-fh-table"> -->
  <template v-if="curCols?.length">
    <div class="fh-table" :ref="$attrs.ref || 'fhTableRefWrap'">
      <qf-table
        :ref="(el) => setRefs(el)"
        v-bind="$attrs"
        :virtual="virtual"
        :rowKey="rowKey"
        :columns="showCol"
        :data="data"
        :filterFieldArray="filterFieldArray"
        :pagination="pagination"
        :bordered="bordered"
        :loading="loading"
        :maxHeight="maxHeight"
        :expandIcon="expandIcon"
        :showColOverlay="showColOverlay"
        :summary="summary"
        :summaryText="summaryText"
        :checkBoxClassName="checkBoxClassName"
        :checkedParams="checkedParams"
        :activeRowKeys="activeRowKeys"
        :errorRowClassName="errorRowClassName"
        @paginationEvent="paginationEvent"
        @rowClick="handleRowClick"
        @headerIconMore="headerIconMore"
        expandType="single"
        :errorRowList="errorRowList"
        @expandChange="expandChange"
        :activeRowType="activeRowType"
        :tableSkeletonRows="tableSkeletonRows"
        @columnResize="columnResize"
        :hasPagination="hasPagination"
        :hasTableHeader="hasTableHeader"
        @handelTableScroll="handelTableScroll"
        :tableOVerflow="tableOVerflow"
        :groupInfo="groupInfo"
        @loadGroupData="loadGroupData"
        :cornerMark="cornerMark"
      >
        <template v-for="(_, name) in $slots" #[name]="slotProps" :key="name">
          <slot :name="name" v-bind="slotProps" />
        </template>
      </qf-table>
    </div>
    <fh-col-select :key="viewId" :cols="cols" :defcols="stateDefCol || {}" ref="tableColSelect" @cb="getCols" @cbIsGroup="getGroupCols"><span></span></fh-col-select>
  </template>
  <fh-list-skeleton v-else></fh-list-skeleton>
  <!-- </div> -->
</template>

<script setup>
import md5 from 'js-md5';
import { ref, computed, watchEffect, useAttrs, onBeforeUnmount, reactive } from 'vue';
import FhListSkeleton from '@/components/fh-list/fh-list-skeleton/fh-list-skeleton.vue';
import CONFIG from '@/config/config';
// import { Message } from '@arco-design/web-vue';
const attrs = useAttrs();

const storage = {
  setItem(key, value) {
    if (key && value) {
      const v = JSON.stringify(value);
      localStorage.setItem(key, v);
      return value;
    }
    return value;
  },
  getItem(key) {
    let v = localStorage.getItem(key);
    if (v !== 'null' && v !== undefined) {
      v = JSON.parse(v);
    }
    return v;
  },
  removeItem(key) {
    return localStorage.removeItem(key);
  }
};

const props = defineProps({
  columns: {
    type: Array,
    default: () => []
  },
  data: {
    type: Array,
    default: () => []
  },
  rowKey: {
    type: String,
    default: 'id'
  },
  bordered: {
    type: Boolean,
    default: false
  },
  viewId: {
    type: [String],
    default: ''
  },
  pagination: {
    type: Object,
    default: () => {}
  },
  loading: {
    type: Boolean,
    default: false
  },
  expandIcon: {
    type: [Boolean, Object],
    default: false
  },
  checkedParams: {
    type: Object,
    default: () => ({
      enabled: true,
      type: 'checkbox',
      width: 40
    })
  },
  activeRowType: {
    type: String,
    default: 'single'
  },
  activeRowKeys: {
    type: Array,
    default: () => []
  },
  showColOverlay: {
    type: Boolean,
    default: false
  },
  filterFieldArray: {
    type: Array,
    default: () => []
  },
  maxHeight: {
    type: Number,
    default: 0
  },
  summary: {
    type: Boolean,
    default: false
  },
  summaryText: {
    type: String,
    default: '合计'
  },
  checkBoxClassName: {
    type: String,
    default: ''
  },
  errorRowClassName: {
    type: String,
    default: ''
  },
  tableSkeletonRows: {
    type: Number,
    default: 10
  },
  errorRowList: {
    type: Array,
    default: () => []
  },
  isChildren: {
    type: Boolean,
    default: false
  },
  tableLevel: {
    type: Number,
    default: 1
  },
  hasPagination: {
    type: Boolean,
    default: true
  },
  hasTableHeader: {
    type: Boolean,
    default: true
  },
  // 分组场景下表格唯一值
  groupKey: {
    type: [String, Number],
    default: ''
  },
  groupInfo: {
    type: Array,
    default: () => []
  },
  tableOVerflow: {
    type: String,
    default: 'scroll'
  },
  virtual: {
    type: Object
  },
  cornerMark: { type: Boolean, default: false }
});
const emits = defineEmits(['paginationEvent', 'rowClick', 'headerIconMore', 'expandChange', 'columnResize', 'handelTableScroll', 'cbGroup', 'loadGroupData', 'columnsChange']);
const curCols = computed(() => props.columns);
const isColsAll = ref('');
// 分页逻辑
const paginationEvent = (current, pageSize) => {
  emits('paginationEvent', current, pageSize);
};
const scrollToTop = (params) => {
  tableRef[`fhTableRef_${props.tableLevel}`].scrollToTop(params);
};
// 行点击逻辑
const handleRowClick = (row) => {
  emits('rowClick', row);
};

// 展开行事件
const expandChange = ({ e, expandRowKeys, row }) => {
  emits('expandChange', { e, expandRowKeys, row });
};

// 表头更多图标的点击事件
const headerIconMore = (params) => {
  emits('headerIconMore', params);
};
// 获取当前显示的列
let c = curCols.value.filter((ele) => ele?.colShow !== false);
// 要传给 列选择的所有列
const cols = ref([]);
cols.value = curCols.value.map((el) => ({ ...el }));
// 要存储到本地数据的列数据
// 生成唯一key

const uniqueKey = curCols.value.length ? curCols.value.map((el) => el.colKey).join('') + curCols.value.length : null;
// 保存默认列和实际列
const tableKey = ref(uniqueKey ? `${CONFIG.prefix}QF_TABLE_COLS_${props.viewId}_${md5(uniqueKey)}` : null);
// 2022-12-23 update 默认列

let defCols = curCols.value.reduce((prev, cur) => {
  const tmp = {};
  if (cur.children?.length) {
    cur.children.forEach((item) => {
      if (item.width) {
        prev[item.colKey] = { width: item.width };
      }
    });
  } else {
    if (cur.width) tmp.width = cur.width;
    if (cur.fixed) tmp.fixed = cur.fixed;
    if (cur.colShow === false) tmp.colShow = cur.colShow;
    prev[cur.colKey] = tmp;
  }
  return prev;
}, {});
let defColsSort = curCols.value
  .sort((a, b) => {
    // 定义优先级函数
    const getPriority = (item) => {
      if (item.fixed === 'left') return 1;
      if (item.fixed === 'right') return 3;
      return 2; // 其他情况
    };
    const aPriority = getPriority(a);
    const bPriority = getPriority(b);
    // 根据优先级排序
    return aPriority - bPriority;
  })
  .map((el) => el.colKey);

// 默认列的值
let kf = storage.getItem(tableKey.value) || { k: defCols, sort: defColsSort };
let kfDef = { k: defCols, sort: defColsSort };
// 设置的宽高
const state = ref(kf);
// 默认的顺序和宽高
const stateDefCol = ref(kfDef);

// 要显示的列
const showCol = ref(c);
if (state.value) {
  const stateCols = state.value.sort.map((el) => {
    let tmp = {};
    const f = curCols.value.find((ele) => ele.colKey === el);
    if (f) {
      tmp = Object.assign({}, { ...f }, { ...state.value?.k[el] });
    }
    return tmp;
  });
  showCol.value = stateCols.filter((el) => el.colShow !== false);
  cols.value = stateCols;
}
const stopWatch = watchEffect(() => {
  // 获取当前显示的列
  c = curCols.value.filter((ele) => ele?.colShow !== false);
  // 要传给 列选择的所有列
  cols.value = curCols.value.map((el) => ({ ...el }));
  defCols = curCols.value.reduce((prev, cur) => {
    const tmp = {};
    if (cur.children?.length) {
      cur.children.forEach((item) => {
        if (item?.width) {
          prev[item.colKey] = { width: item.width };
        }
      });
    } else {
      if (cur.width) tmp.width = cur.width;
      if (cur.fixed) tmp.fixed = cur.fixed;
      if (cur.colShow === false) tmp.colShow = cur.colShow;
      prev[cur.colKey] = tmp;
    }
    return prev;
  }, {});
  defColsSort = curCols.value
    .sort((a, b) => {
      // 定义优先级函数
      const getPriority = (item) => {
        if (item.fixed === 'left') return 1;
        if (item.fixed === 'right') return 3;
        return 2; // 其他情况
      };
      const aPriority = getPriority(a);
      const bPriority = getPriority(b);
      // 根据优先级排序
      return aPriority - bPriority;
    })
    .map((el) => el.colKey);
  // 默认列的值
  kf = storage.getItem(tableKey.value) || { k: defCols, sort: defColsSort };
  kfDef = { k: defCols, sort: defColsSort };
  // 设置的宽高
  if (curCols.value.length) {
    state.value = storage.setItem(tableKey.value, kf);
    stateDefCol.value = storage.setItem(`${tableKey.value}_DEFAULT`, kfDef);
  }
  emits('columnResize', kf, showCol.value);
  // 2022-12-23 update 默认列
  // 要显示的列
  if (state.value) {
    const stateCols = state.value.sort.map((el) => {
      let tmp = {};
      const f = curCols.value.find((ele) => ele.colKey === el);
      if (f?.children?.length) {
        // 子表单处理 colshow
        let subColshow = null;
        f.children.forEach((child) => {
          const isWidth = state.value?.k?.[child.colKey]?.width;
          child.width = isWidth ? isWidth : child?.width;
          subColshow = { ...state.value?.k?.[child.colKey] };
        });
        // 如何根据else中的方式改写，返回这个
        tmp = Object.assign({}, { ...f }, { ...subColshow });
      } else {
        // 以下是正确的
        tmp = Object.assign({}, { ...f }, { ...state.value?.k[el] });
        if (!state.value?.k[el]?.fixed && tmp?.fixed) {
          delete tmp.fixed;
        }
      }
      return tmp;
    });
    const formatSortShowCol = [];
    stateCols
      .filter((el) => el.colShow !== false)
      .map((scv) => {
        if (attrs?.sortOrder?.colKey && attrs?.sortOrder?.colKey == scv.colKey) {
          scv.sortable['sortOrder'] = attrs?.sortOrder?.sortOrder;
        } else {
          if (scv.sortable?.sortOrder) delete scv.sortable?.sortOrder;
        }
        formatSortShowCol.push(scv);
      });
    showCol.value = formatSortShowCol;
    cols.value = stateCols;
  }
});
// 这是列选择相关代码 S
const tableColSelect = ref(null);
const openColSelect = (v = null) => {
  if (v) {
    isColsAll.value = v;
  }
  tableColSelect.value?.openDialog();
};

const getGroupCols = (v) => {
  emits('cbGroup', v);
};

// 获取列选择的值
const getCols = (v) => {
  let c = [...v];
  // 要移动的对象的条件
  const fixColumnsKeys = [];
  c.forEach((cItem) => {
    if (['custom-operations'].includes(cItem.colKey)) {
      fixColumnsKeys.push(cItem.colKey);
    }
  });

  // 找到符合条件的对象的索引
  const firstTwoKeys = c.slice(0, fixColumnsKeys.length)?.map((sItem) => sItem.colKey); // 前两项的key
  const missingKeys = fixColumnsKeys.filter((key) => !firstTwoKeys.includes(key));

  if (missingKeys.length > 0) {
    const itemsToMove = c.filter((item) => fixColumnsKeys.includes(item.colKey)); //固定的前两项目
    const remainingItems = c.filter((item) => !fixColumnsKeys.includes(item.colKey)); // 剩余的其他项
    c = [...itemsToMove, ...remainingItems];
  }

  const cf = c.filter((el) => el.colShow !== false);
  const kfc = {
    k: c.reduce((prev, cur) => {
      const tmp = {};
      if (cur.children?.length) {
        cur.children.forEach((item) => {
          if (item?.width) {
            prev[item.colKey] = { width: item.width };
          }
          // 子表单处理 colshow
          prev[item.colKey].colShow = cur.colShow;
        });
      } else {
        if (cur.width) tmp.width = cur.width;
        if (cur.fixed) tmp.fixed = cur.fixed;
        if (cur.colShow === false) tmp.colShow = cur.colShow;
        prev[cur.colKey] = tmp;
      }
      return prev;
    }, {}),
    sort: c.map((el) => el.colKey)
  };
  state.value = kfc;
  state.value = storage.setItem(tableKey.value, kfc);
  showCol.value = cf.map((el) => ({ ...el }));
  emits('columnsChange');
};
// 这是列选择相关代码 E

// 调整列宽
// const timerRef = ref(null);
const columnResize = (width) => {
  const s = storage.getItem(tableKey.value);
  if (s) {
    state.value = storage.setItem(tableKey.value, { ...s, k: { ...s.k, ...width } });
    emits('columnResize', state.value, showCol.value);
  }
};
// :onColumnMinWidthReached="handleColumnMinWidthReached"
// const handleColumnMinWidthReached = (col) => {
//   // 在这里处理列宽达到最小宽度的情况
//   // Message.warning('该字段列宽已达最小宽度！');
// };

const tableRef = reactive({});
// 存储对应的子组件实例
const setRefs = (el) => {
  tableRef[`fhTableRef_${props.tableLevel}`] = el;
};
// 刷新行数据
const refreshRow = (rk) => {
  tableRef[`fhTableRef_${props.tableLevel}`]?.refreshRow(rk);
};
// 提供修改行数据的z-index方法
const updateZIndex = ({ rowKey, zIndex }) => {
  if (!tableRef[`fhTableRef_${props.tableLevel}`]) return;
  tableRef[`fhTableRef_${props.tableLevel}`]?.updateZIndex({ rowKey, zIndex });
};
// 分组默认加载数据事件，当最后一层级的分组出现在视口内时，会触发该事件，一般用于调用数据接口
const loadGroupData = (params) => {
  emits('loadGroupData', params);
};
// qf-table表格的行滚动事件
const tableScrollEvent = (params) => {
  tableRef[`fhTableRef_${params.level || 1}`]?.tableScrollEvent(params);
};
// 获取qf-table组件的ref
const getTableRef = (level = 1) => {
  return tableRef[`fhTableRef_${level}`]?.qfTableRef;
};
// 获取滚动容器的ref
const getScrollContainerRef = (level = 1) => {
  return tableRef[`fhTableRef_${level}`]?.qfTableScrollContainerRef;
};
// 获取Qf-table的表体实例方法
const getTableBodyRef = (level = 1) => {
  return tableRef[`fhTableRef_${level}`]?.qfTableBodyRef;
};
// 获取Qf-table的表头实例方法
const getTableHeaderRef = (level = 1) => {
  return tableRef[`fhTableRef_${level}`]?.qfTableHeaderStickyRef;
};
// 获取左侧固定列最后一列到视口左侧的距离
// 该方法在2025年06月25号去除，原因是修改编辑组件的展示逻辑，不再需要该方法，即使需要qf-table内部已经有方法直接获取，无需使用该方法
const getFixedLeftLastCellRect = (level = 1) => {
  const element = document.querySelectorAll('.qf-table-header-fixed-left-last');
  if (element.length) {
    const rect = element[level - 1]?.getBoundingClientRect();
    return rect;
  }
  return null;
};
// 表格整体滚动事件
const handelTableScroll = (params) => {
  emits('handelTableScroll', params);
};
const getGroupKey = () => {
  return props.groupKey;
};
onBeforeUnmount(() => {
  showCol.value = [];
  stateDefCol.value = null;
  isColsAll.value = null;
  cols.value = [];
  if (stopWatch) {
    stopWatch();
  }
  tableRef[`fhTableRef_${props.tableLevel}`] = null;
  tableColSelect.value = null;
});
// 导出子组件
defineExpose({
  tableColSelect,
  scrollToTop,
  getCols,
  refreshRow,
  tableScrollEvent,
  openColSelect, // 列选择的ref
  getFixedLeftLastCellRect,
  getGroupKey,
  groupKey: props.groupKey,
  getTableBodyRef,
  getTableHeaderRef,
  updateZIndex,
  getScrollContainerRef,
  getTableRef,
  showCol
});
</script>
<style scoped lang="less">
@import './fh-table.less';
</style>
